import withHydrationOnDemand from '@react/services/withHydrationOnDemand';
import dynamic from 'next/dynamic';

const withHydration = (loadFn) => {
  const Component = dynamic(loadFn);

  return withHydrationOnDemand({
    on: ['visible'],
    onBefore: Component.render.preload,
  })(Component);
};

export default withHydration;
